import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import AxiosInstance from '../AxiosInstance';
import { FaHome, FaSignOutAlt, FaUserCircle, FaProjectDiagram, FaCalendarAlt, FaClock, FaUser, FaBars } from "react-icons/fa";
import '../../stylesheet.css';
import Footer from "../Footer";
import ToastNotification from "../ToastNotification";
import { employeeMenuConfig } from "../menuconfig"; // ✅ Import config

const ELayout = ({ children, heading }) => {
  const [fullName, setFullName] = useState('');
  const navigate = useNavigate();
  const [profileImage, setProfileImage] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(
    localStorage.getItem("sidebarOpen") === "true"
  );
  const location = useLocation();
  const toastRef = useRef(null);
  const userId = localStorage.getItem('employeeId');
  const imageUrl = process.env.REACT_APP_BASE_URL + '/uploads/';

  useEffect(() => {
    if (userId) {
      AxiosInstance.get(`/common/user/${userId}`)
        .then((response) => {
          setFullName(response.data.full_name);
          setProfileImage(response.data.image_profile);
        })
        .catch((error) => {
          toastRef.current?.showToast('Error fetching user details:', "danger");
        });
    } else {
      toastRef.current?.showToast('User not logged in or userId not found.', "danger");
      navigate('/');
    }
  }, [userId, navigate]);

  const handleLogout = () => {
    localStorage.removeItem('employeeId');
    navigate('/');
  };

  const handleHomeNavigation = () => {
    navigate('/home');
  };

  const handleAccountNavigation = () => {
    navigate('/EAccount');
  };

  const toggleSidebar = () => {
    setSidebarOpen((prev) => {
      const newState = !prev;
      localStorage.setItem("sidebarOpen", newState);
      return newState;
    });
  };

  useEffect(() => {
    const savedState = localStorage.getItem("sidebarOpen") === "true";
    setSidebarOpen(savedState);
  }, []);

  return (
    <div className="page wrapper d-flex flex-column min-vh-100">
      <div className={`layout-container flex-grow-1 ${sidebarOpen ? '' : 'sidebar-closed'}`}>
        <div
          className={`sidebar ${sidebarOpen ? '' : 'collapsed'}`}
          onMouseEnter={() => setSidebarOpen(true)}
          onMouseLeave={() => setSidebarOpen(false)}
        >
          <div style={{ display: "flex" }}>
            <h4 className="text-left mb-4">FinGlider</h4>
            <button
              className="btn btn-link me-2 text-white"
              onClick={toggleSidebar}
              style={{ fontSize: '20px', float: "right" }}
            >
              <FaBars />
            </button>
          </div>

          <nav className="nav flex-column">
            {/* ✅ Dynamic Menu Items based on employeeMenuConfig */}
            {employeeMenuConfig.profile && (
              <Link
                to="/profile"
                className={`nav-link text-white d-flex align-items-center ${location.pathname === '/profile' ? 'active' : ''}`}
              >
                <FaUserCircle className="me-2" />
                <span>Profile</span>
              </Link>
            )}
            {employeeMenuConfig.projects && (
              <Link
                to="/EProject"
                className={`nav-link text-white d-flex align-items-center ${location.pathname === '/EProject' ? 'active' : ''}`}
              >
                <FaProjectDiagram className="me-2" />
                <span>Projects</span>
              </Link>
            )}
            {employeeMenuConfig.leaves && (
              <Link
                to="/Eleaves"
                className={`nav-link text-white d-flex align-items-center ${location.pathname === '/Eleaves' ? 'active' : ''}`}
              >
                <FaCalendarAlt className="me-2" />
                <span>Leaves</span>
              </Link>
            )}
            {employeeMenuConfig.timesheet && (
              <Link
                to="/weeksTimesheet"
                className={`nav-link text-white d-flex align-items-center ${location.pathname === '/TimesheetTable' ? 'active' : ''}`}
              >
                <FaClock className="me-2" />
                <span>Timesheet</span>
              </Link>
            )}
          </nav>
        </div>

        <div className="main-content flex-grow-1">
          <div className="navbar-container">
            <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm" style={{ padding: '0.5rem 1rem' }}>
              <div className="container-fluid d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <button
                    className="btn btn-link text-dark"
                    onClick={handleHomeNavigation}
                    style={{ fontSize: '20px', padding: '0' }}
                  >
                    <FaHome />
                  </button>
                </div>

                <div className="dropdown">
                  <button
                    className="btn btn-link"
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{
                      fontSize: '16px',
                      padding: '0',
                      color: 'black',
                      textDecoration: 'none',
                      textTransform: 'capitalize',
                      border: 'none',
                      outline: 'none'
                    }}
                  >
                    {fullName}
                    {profileImage ? (
                      <img
                        src={`${imageUrl + profileImage}`}
                        alt="Profile"
                        style={{ width: '30px', height: '30px', borderRadius: '50%', objectFit: 'cover', marginLeft: '10px' }}
                      />
                    ) : (
                      <FaUserCircle style={{ width: '30px', height: '30px', color: 'gray', marginLeft: '10px' }} />
                    )}
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                    <li>
                      <button className="dropdown-item d-flex align-items-center" onClick={handleAccountNavigation}>
                        <FaUser className="me-2" />
                        Account
                      </button>
                    </li>
                    <li>
                      <button className="dropdown-item d-flex align-items-center" onClick={handleLogout}>
                        <FaSignOutAlt className="me-2" />
                        Logout
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>

          <div className="content flex-grow-1">
            <div className="content-container">
              <h4 style={{ fontSize: '20px', color: 'grey', textTransform: 'capitalize' }}>{heading}</h4>
              {children}
            </div>
          </div>
        </div>
        <ToastNotification ref={toastRef} />
      </div>
      <Footer />
    </div>
  );
};

export default ELayout;
